import Stimulus from "stimulus_init"
import AvatarUploadController from "controllers/avatar_upload_controller"
import ConfettiController from "controllers/confetti_controller"
import DependentSelectController from "controllers/dependent_select_controller"
import LoadMoreController from "controllers/load_more_controller"
import PreferencesCheckboxController from "controllers/newsletters/preferences_checkbox_controller"
import TabsController from "controllers/tabs_controller"

Stimulus.register("avatar-upload", AvatarUploadController)
Stimulus.register("confetti", ConfettiController)
Stimulus.register("dependent-select", DependentSelectController)
Stimulus.register("load-more", LoadMoreController)
Stimulus.register("newsletters--preferences-checkbox", PreferencesCheckboxController)
Stimulus.register("tabs", TabsController)
